import React, { useEffect, useState } from "react";
import { oracleGet } from "../../lib/api";
import { WallPanels } from "../NexusWall";
import { Card } from "./TvBits";

const KalshiBoard = ({ userId }) => {
  const [board, setBoard] = useState(null);
  useEffect(() => { oracleGet(userId).then((d) => setBoard(d.board || [])).catch(() => setBoard([])); }, [userId]);
  return (
    <Card title="KALSHI · ORACLE BOARD" accent="#A855F7" className="h-full" testid="tv-kalshi-board">
      {board === null && <p className="text-2xl text-cyan-100/40">Loading…</p>}
      <div className="space-y-4">
        {(board || []).slice(0, 7).map((b) => (
          <div key={b.ticker} className="flex items-center gap-4 text-2xl">
            <span className="flex-1 text-cyan-50 truncate">{b.title}</span>
            <b className={b.side === "yes" ? "text-emerald-300" : "text-rose-300"}>{(b.side || "").toUpperCase()} {Math.round((b.ask || 0) * 100)}¢</b>
            <span className="text-purple-300 w-28 text-right">edge {Math.round((b.edge || 0) * 100)}%</span>
          </div>
        ))}
        {board && !board.length && <p className="text-2xl text-cyan-100/40">No Kalshi opportunities right now.</p>}
      </div>
    </Card>
  );
};

export const TvMoney = ({ view, userId }) => (
  <div className="absolute inset-0 z-40 bg-[#030712]/95 rounded-3xl p-2 nx-fade-up" data-testid={`tv-money-${view}`}>
    {view === "pnl" ? <WallPanels userId={userId} /> : <KalshiBoard userId={userId} />}
  </div>
);
